export enum TranslationStatusEnum {
	IN_PROGRESS = 'IN_PROGRESS',
	COMPLETED = 'COMPLETED',
	ERROR = 'ERROR',
}
